import { render, staticRenderFns } from "./planningInvestor.vue?vue&type=template&id=3a05ed9e&"
import script from "./planningInvestor.vue?vue&type=script&lang=js&"
export * from "./planningInvestor.vue?vue&type=script&lang=js&"
import style0 from "./planningInvestor.vue?vue&type=style&index=0&id=3a05ed9e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports